export default __webpack_public_path__ + "static/myalgo-f566bf1672ec8ca56372447da3546eee.png";